export default "__VITE_ASSET__DsuIvRsl__"